import { CreateExcel } from "@jurinfor/js-excel";
import Sheet from "./Sheet";

export default class Spreadsheet {
  /**
   * @param {Sheet} sheets - массив страниц
   */
  constructor(sheets) {
    this.sheets = sheets;
  }

  /**
   * Порождает XLS-файл.
   */
  createExcel() {
    const sheetData = this.sheets.map(({ title, frag: { data } }) => ({ title, data }));
    const sheetMarkdown = Object.fromEntries(this.sheets.map(({ title, frag }) => ([ title, frag.markdown ])));
    const sheetColumnWidth = Object.fromEntries(this.sheets.map(({ title, frag }) => ([ title, frag.columnWidth ])));
    const sheetRowHeight = Object.fromEntries(this.sheets.map(({ title, frag }) => ([ title, frag.rowHeight ])));
    const sheetDiags = {};
    // const s = (x) => (JSON.stringify(x).length < 100 ? JSON.stringify(x) : JSON.stringify(x, null, '  '));
    // console.log(`createExcel(${s(sheetData)}, "", ${s(sheetMarkdown)}, ${s(sheetColumnWidth)}, ${s(sheetRowHeight)}, ${s(sheetDiags)}, true, (e) => console.error(e))`);
    CreateExcel(
      sheetData,
      "",
      sheetMarkdown,
      sheetColumnWidth,
      sheetRowHeight,
      sheetDiags,
      true,
      (e) => console.error(e),
    );
  }
}
